var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"damage-points"},[_vm._t("default"),_vm._l((_vm.points),function(pin,index){return _c('div',{staticClass:"component-pin",style:({ top:pin.top+'px', left: pin.left + 'px'})})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }